/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-favorite-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.979 2.66a2.632 2.632 0 00-3.604-.14 2.632 2.632 0 00-3.604.14 2.7 2.7 0 000 3.777l3.603 3.65h.002l3.603-3.65a2.7 2.7 0 000-3.777zm-.89 2.9l-2.713 2.747h-.002L11.66 5.56a1.443 1.443 0 010-2.02 1.415 1.415 0 011.973 0l.738.754.003-.004.003.004.738-.755a1.415 1.415 0 011.973 0c.55.561.55 1.46 0 2.021zM10 18.75H8.75v-3.125a1.877 1.877 0 00-1.875-1.875h-2.5A1.877 1.877 0 002.5 15.625v3.125H1.25v-3.125A3.129 3.129 0 014.375 12.5h2.5A3.129 3.129 0 0110 15.625v3.125zM5.625 6.25a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
